<template>
    <div class="story-maker-sticker story-maker-sticker-question" :class="{edit: isEditing}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="changeColor">
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <div class="sticker sticker-question" 
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : '',
                backgroundColor: models.color
            }"
            :class="[`color-${models.color.slice(1).toUpperCase()}`]"
        >

            <div class="container-picture-image">
                <div 
                    class="picture-page"
                    :style="{ 
                        borderColor: models.color
                    }"
                >
                    <img :src="$attrs.pageSelected && $attrs.pageSelected.avatar ? $attrs.pageSelected.avatar : 'img/avatar.jpg'">
                </div>
            </div>
            <div 
                class="question-header"
            >
                    <textarea cols="20" rows="2" wrap="hard" maxlength="100" :placeholder="$t('dash.post-creator.story.question-placeholder')" v-model="models.question" :readonly="!isEditing"></textarea>
            </div>
            <div class="fake-input">
                    <p v-if="isEditing">{{ $t('dash.post-creator.story.question-people-answer') }}</p>
                    <p v-else>{{ $t('dash.post-creator.story.question-enter-something') }}</p>
            </div>
            
        </div>
        
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';

    const colorsHeader = ["#FFFFFF","#0C0F14", "#FF0164", "#FD01D2", "#8A2EFF", "#FF6300", "#00D93D", "#009BFF", "#00CBFE"]
    export default {
        props: {
            id: Number | String,
            isEditing: Boolean,
            question: String,
            color: String,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },

        data() {
            return {
                timeoutFinish: null,
                models : {
                    question: "",
                    color:''
                }
            }
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.clickSticker);
            EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);
        },

        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },

            saveCurrentState() {
                if (!this.isEditing) return;
                if (!this.models.question) this.$set(this.models, 'question', 'Posez-moi une question');
                this.$emit('updateSticker', this.id, {
                    isEditing: false,
                    data: {
                        question: this.models.question,
                        color: this.models.color
                    },
                });
                if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
                this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
            },

            finish(event) {
                if (this.isCover && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    this.saveCurrentState();
                }
            },

            changeColor() {
                const index = colorsHeader.findIndex((color)=> color == this.models.color)
                this.models.color = colorsHeader[(index+1)%colorsHeader.length]                
            }
        },

        beforeDestroy() {
            EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
        },

        watch: {
            question: {
                handler(newValue) {
                    this.models.question = newValue
                },
                immediate: true
            },
            color: {
                handler(newValue) {
                    this.models.color = newValue
                },
                immediate: true
            },
            isEditing: {
                handler(newValue) {
                    if (newValue && !this.isPreventCover && !this.isCover) {
                    this.isEditing = false
                    this.clickSticker()
                }
                },
                immediate: true
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
<!-- https://vuejs.org/guide/built-ins/transition-group -->